type Row = { client: string; amount: number };

const rows: Row[] = [
  { client: 'Nightingale Co.', amount: 812.34 },
  { client: 'Harbor Studios', amount: 540.11 },
  { client: 'Pellet Labs', amount: 361.6 },
  { client: 'Foxglove Inc.', amount: 248.0 },
  { client: 'Cedar & Co.', amount: 185.83 },
];

const fmt = (value: number) =>
  value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function ReceiptVisual() {
  const total = rows.reduce((sum, row) => sum + row.amount, 0);
  return (
    <div
      className="bg-card border-2 border-border"
      style={{ boxShadow: '8px 8px 0 0 hsl(var(--accent))' }}
    >
      <div className="px-6 pt-6 pb-5 flex items-baseline justify-between border-b-2 border-border">
        <div>
          <div className="text-[11px] font-bold uppercase tracking-[0.18em] text-spray-yellow">
            Apr 2026 · Summary
          </div>
          <div className="mt-2 text-4xl font-display num">${fmt(total)}</div>
        </div>
        <div className="text-[10px] font-bold uppercase tracking-wider px-2 py-1 bg-spray-yellow text-primary-foreground">
          100% Allocated
        </div>
      </div>

      <div className="px-6 py-5">
        <div className="flex items-center justify-between text-[10px] uppercase tracking-wider text-muted-foreground font-mono mb-3 font-bold">
          <span>Client</span>
          <span>Cost (USD)</span>
        </div>
        <ul className="space-y-3 font-mono text-sm">
          {rows.map((row) => (
            <li key={row.client} className="flex items-baseline justify-between">
              <span className="text-foreground">{row.client}</span>
              <span className="num text-foreground font-bold">${fmt(row.amount)}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="px-6 py-4 border-t-2 border-border flex items-baseline justify-between font-mono text-base font-bold uppercase">
        <span>Total</span>
        <span className="num text-spray-yellow">${fmt(total)}</span>
      </div>

      <div className="px-6 pb-5">
        <button
          type="button"
          className="w-full text-xs font-bold uppercase tracking-wider text-foreground border-2 border-border py-2.5 hover:bg-muted transition-colors"
        >
          Export CSV →
        </button>
      </div>
    </div>
  );
}
